import React from 'react';
import { Divider, DividerProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

export const useStyles = makeStyles(() => ({
  root: {
    background: '#EDEDED',
    // @ts-ignore
    marginTop: (props) => (props.mTop ? props.mTop : '20px'),
    // @ts-ignore
    marginBottom: (props) => (props.mBottom ? props.mBottom : '20px'),
  },
}));

type PBaseDivider = DividerProps & {
  mTop?: string;
  mBottom?: string;
  className?: any;
};

export const BaseDivider: React.FC<PBaseDivider> = (props) => {
  const classes = useStyles(props);
  const { className } = props;
  return (
    <Divider className={clsx(classes.root, className)} variant="fullWidth" />
  );
};
